import server from 'common/utils/server';
import {
  startCoachingSessionRequest,
  finishCoachingSessionRequest,
  formatPublicNote
} from './coachingSession';

export const updateCoachingSessionPublicNote = (
  coachingSessionId,
  createdById,
  notes
) => dispatch => {
  dispatch(startCoachingSessionRequest());
  server
    .put(`/api/v1/coaching/coaching_session/${coachingSessionId}/public_note`, {
      created_by_id: createdById,
      notes,
    })
    .then(publicNoteJSON => {
      const publicNote = formatPublicNote(publicNoteJSON);
      dispatch({
        type: 'UPDATE_PUBLIC_NOTE',
        publicNote,
      });
      dispatch(finishCoachingSessionRequest());
    });
};

export const coachingSessionPublicNotes = (state = [], action) => {
  switch (action.type) {
    case 'LOADED_COACHING_SESSION': {
      const { publicNotes } = action;
      return publicNotes;
    }
    case 'UPDATE_PUBLIC_NOTE': {
      const { publicNote } = action;
      const updatedPublicNotes = state.map(note => {
        return note.createdById === publicNote.createdById
          ? { ...note, ...publicNote }
          : note;
      });

      return [...updatedPublicNotes];
    }
    default: {
      return state;
    }
  }
};
